import React from "react";
import { Chip, Tooltip } from "@mui/material";

export const SALE_TRANSACTION_TYPE = "sale";

export function isSaleTransaction(tx) {
    return String(tx?.transaction_type || "").toLowerCase() === SALE_TRANSACTION_TYPE;
}

export function filterSaleTransactions(transactions) {
    return (Array.isArray(transactions) ? transactions : []).filter(isSaleTransaction);
}

/** Statuts affichés tels quels — ne pas exclure PROCESSED_ERRORS. */
export function getTransactionStatusMeta(tx) {
    const status = String(tx?.status || "").toUpperCase();
    const type = String(tx?.transaction_type || "");
    const errorCode = tx?.error_code ? String(tx.error_code) : "";

    if (status === "PROCESSED") {
        return { label: "Traitée", color: "success", severity: "success", helper: null };
    }
    if (status === "PROCESSED_ERRORS") {
        return {
            label: "Erreur points",
            color: "warning",
            severity: "warning",
            helper: "Vente enregistrée, points non crédités",
        };
    }
    if (type === "CUSTOMER_REGISTRATION" && errorCode === "NO_RULES") {
        return { label: "Inscription", color: "default", severity: "info", helper: null, hideAsError: true };
    }
    if (status) {
        return { label: status, color: "default", severity: "default", helper: tx?.error_message || null };
    }
    return { label: "—", color: "default", severity: "default", helper: null };
}

export function TransactionStatusChip({ transaction, size = "small" }) {
    const meta = getTransactionStatusMeta(transaction);
    const chip = (
        <Chip
            label={meta.label}
            size={size}
            color={meta.color === "default" ? undefined : meta.color}
            variant={meta.color === "default" ? "outlined" : "filled"}
            sx={{ fontWeight: 700, fontSize: 10 }}
        />
    );
    const title = [meta.helper, transaction?.error_message].filter(Boolean).join(" — ");
    return title ? <Tooltip title={title}>{chip}</Tooltip> : chip;
}

export function getOrderNumber(tx) {
    const payload = tx?.payload || {};
    return tx?.transaction_id
        || payload.orderNumber
        || payload.order_number
        || "—";
}

export function getOrderTotal(tx) {
    const payload = tx?.payload || {};
    const raw = payload.orderTotal ?? payload.total ?? payload.amount;
    if (raw == null || raw === "") return "—";
    return typeof raw === "number" ? raw.toLocaleString("fr-FR") : String(raw);
}

export function getProductSummary(tx) {
    const payload = tx?.payload || {};
    const names = payload.productNames || payload.product_names;
    if (!Array.isArray(names) || names.length === 0) return "—";
    if (names.length <= 2) return names.join(", ");
    return `${names.slice(0, 2).join(", ")} (+${names.length - 2})`;
}

export function formatTxDateTime(tx) {
    const raw = tx?.processed_at || tx?.created_at;
    return raw ? new Date(raw).toLocaleString("fr-FR") : "—";
}
